import React from 'react';
import { EntityTaskDetails } from 'components/common/tasks/entityTaskDetails';

export const ItemTaskDetails = () => {
  return <EntityTaskDetails entityName={'ITEM'} />;
};
